import React from 'react'
import { Row, Col, Form, InputGroup, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

const MerchantInfo = ({merchantInfo, onChange, onClickFindMerchant, action}) => {
    return (
        <React.Fragment>
            <Row>
                <Col sm={12} className="font-weight-bold">
                    Merchant Information
                </Col>
            </Row>
            <Row className="my-3">
                <Col sm={12}>
                    <Row>                    
                        <Col sm={6}>
                            <Form.Group controlId="merchantId">
                                <Form.Label className="text-grey font-weight-bold medium required">Merchant ID</Form.Label>
                                <InputGroup>                                
                                <Form.Control
                                    name="merchantId" type="text" placeholder="Enter merchant ID"
                                    pattern="\d{10}"
                                    maxLength="10"
                                    title="Merchant ID must be 10 digits only"
                                    value={merchantInfo ? merchantInfo.merchantId : ''}
                                    onChange={(e) => onChange('merchantInfo', e.target.name, e.target.value, "NUMERIC")}
                                    form="merchantFindingForm"
                                    disabled={action !== 'create'}
                                    required
                                />
                                {action === 'create' &&
                                <InputGroup.Append>
                                    <Button onClick={onClickFindMerchant} form="merchantFindingForm" type="submit" variant="secondary">
                                    <FontAwesomeIcon size="lg" icon={faSearch}/>
                                    </Button>
                                </InputGroup.Append>
                                }
                                </InputGroup>
                            </Form.Group>
                        </Col>
                        <Col sm={6}>
                            <Form.Group controlId="merchantName">
                            <Form.Label className="text-grey font-weight-bold medium">Merchant Name</Form.Label>
                            <Form.Control
                                name="merchantCode" type="text"
                                placeholder="Merchant name"
                                disabled={true}
                                value={merchantInfo ? merchantInfo.merchantName : ''}
                            />
                            </Form.Group>
                        </Col>                          
                    </Row>
                </Col>
            </Row>
        </React.Fragment>
    )
}

export default MerchantInfo
